export const CONTRIBUTIONS_CACHE = 'contributions';
export const COMMUNITY_MEMBERS_CACHE = 'community_members';
export const QUESTIONS_CACHE = 'questions';
export const TASKS_CACHE = 'tasks';
